<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1920 1066"
  >
    <polygon
      class="cls-2"
      data-floor="2"
      points="348 740 428 820 432 821 437 821 441 821 446 821 448 821 450 820 451 819 460 828 448 836 448 838 448 839 448 841 449 843 536 927 542 928 548 929 557 929 560 929 566 928 1491 684 1491 665 1472 658 566 883 557 884 545 884 538 883 533 882 446 801 445 798 445 794 447 792 453 790 456 789 456 787 449 781 433 783 430 783 426 782 422 778 357 717 347 720 345 723 345 729 346 738 348 740"
    />
    <polygon
      class="cls-2"
      data-floor="3"
      points="345 707 357 717 426 782 430 783 433 783 449 781 456 787 456 789 447 792 445 794 445 798 446 801 500.15 851.41 533 882 538 883 545 884 557 884 566 883 588.49 877.41 1472 658 1493 653 1493 634 1472 631 1472 628 560 838 551 839 541 839 534 838 528 835 443 762 443 754 454 749 448 743 441 744 430 744 426 743 423 742 354 683 344 687 345 707"
    />
    <polygon
      class="cls-2"
      data-floor="4"
      points="342 672 354 683 423 742 430 744 441 744 448 743 454 749 443 754 443 762 528 835 534 838 541 839 551 839 560 838 1472 628 1495 622 1495 603 1475 596 565 791 552 793 538 793 528 791 522 787 440 721 440 713 450 710 450 708 441 702 437 704 422 704 352 648 352 656 342 656 342 672"
    />
    <polygon
      class="cls-2"
      data-floor="5"
      points="338 635 352 648 422 704 437 704 441 702 450 708 450 710 440 713 440 721 522 787 528 791 538 793 552 793 565 791 596.95 784.15 1475 596 1499 591 1499 572 1476 566 1472 565 555 746 543 747 528 745 522 743 436 679 436 664 424 664 418 663 344 606 344 616 338 616 338 635"
    />
    <polygon
      class="cls-2"
      data-floor="6"
      points="344 606 418 663 424 664 436 664 436 679 522 743 528 745 543 747 555 746 672.28 722.85 1472 565 1500 559 1500 540 1480 538 1480 532 551 699 537 700 525 698 516 695 433 637 433 624 416 624 349 577 349 579 336 581 336 598 344 606"
    />
    <polygon
      class="cls-2"
      data-floor="7"
      points="333 566 349 577 416 624 433 624 433 637 516 695 525 698 537 700 551 699 1480 532 1503 527 1503 509 1480 505 1480 497 580 646 549 651 537 652 525 652 519 650 429 593 429 583 420 584 415 583 410 581 344 537 344 544 333 547 333 566"
    />
    <polygon
      class="cls-2"
      data-floor="8"
      points="344 537 410 581 415 583 420 584 429 583 429 593 519 650 525 652 537 652 549 651 631.43 637.49 1480 497 1505 493 1505 477 1480 473 1480 467 542 604 534 604 525 604 517 603 425 551 425 542 416 542 410 542 407 541 344 503 344 510 331 510 331 528 344 537"
    />
    <polygon
      class="cls-2"
      data-floor="9"
      points="328 494 344 503 370.66 519.08 407 541 410.76 542 425 542 425 551 517 603 525 604 542 604 1480 467 1506 463 1506 443 1480 440 1480 432 550 553 535 554 520 554 510 552 424 507 424 499 419 500 411 500 404 498 336 463 336 473 325 473 325 492 328 494"
    />
    <polygon
      class="cls-2"
      data-floor="10"
      points="325 456 336 463 404 498 411 500 419 500 424 499 424 507 510 552 520 554 536.1 554 550 553 686.62 535.23 1034.76 489.93 1480 432 1506 429 1506 409 1479 403 1479 399 1443 403 1379 410 1208 429 674 489 660 489 647 489 641 487 560 494 547 494 538 494 526 494 518 493 508 491 497 492 486 491 421 463 421 456 413 456 403 455 341 427 336 437 325 438 325 456"
    />
    <polygon
      class="cls-2"
      data-floor="11"
      points="334 424 341 427 403 455 413 456 421 456 421 463 486 491 497 492 508 491 518 493 526 494 537.11 494 560 494 641 487 647 489 674 489 1458.58 401.27 1472.34 399.74 1480 399 1481 366 550 454 526 456 513 455 418 421 418 415 410 415 400 414 338 391 336 392 334 394 334 424"
    />
    <polygon
      class="cls-2"
      data-floor="12"
      points="321 384 338 391 400 414 410 415 418 415 418 421 513 455 526 456 570.24 452.09 744.24 435.64 1224.86 390.21 1481 366 1511 364 1511 345 1484 344 1484 335 1448 336 668 396 655 397 642 395 556 399 534 399 520 398 504 397 495 398 484 398 475 396 416 379 416 373 406 373 397 372 334 352 332 355 330 359 330 363 321 364 321 384"
    />
    <polygon
      class="cls-2"
      data-floor="13"
      points="328 350 334 352 397 372 406 373 416 373 416 379 475 396 484 398 495 398 504 397 523.29 398.24 533.46 398.96 541.22 399 556 399 575.25 398.11 642 395 655 397 1484 335 1485 301 1488 301 1488 298 1486 298 1486 261 1488 261 1488 248 1355 243 1310 244 1175 247 1124 249 1038 251 989 252 895 248 881 247 848 247 803 248 734 249 661 251 551 253 450 257 450 288 436 288 340 292 337 293 337 296 338 313 334 314 330 316 328 320 328 350"
    />
  </svg>
</template>

<script>
export default {
  mounted() {
    this.$emit('changed');
  },
};
</script>
